@if (gates$ | async; as gates) {
  <div class="flex justify-center">
    <div class="w-full max-w-screen-xl px-4 py-6">
      <!-- Header -->
      <div class="flex flex-col sm:flex-row items-start md:items-center justify-between gap-4 pb-4 border-b border-surface">
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-3">
            <i class="pi pi-building !text-2xl text-900"></i>
            <span class="text-3xl font-semibold text-900">Your Gates</span>
          </div>
          <p class="text-gray-500 m-0">Manage and monitor your access points</p>
        </div>
        <button
          *appHasRole="UserRole.SuperAdmin"
          aria-label="Add Gate"
          class="self-end md:self-center"
          icon="pi pi-plus"
          label="Add Gate"
          pButton
          pRipple
          routerLink="/dashboard/gate/new"
          type="button"></button>
      </div>
      <!-- Gates Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        @for (gate of gates; track gate) {
          <div class="w-full">
            <div
              class="bg-white dark:bg-surface-800 rounded-lg border border-gray-200 dark:border-surface-600 p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-surface-700 transition-colors duration-150"
              [routerLink]="['/dashboard/gate', gate.id]">
              <!-- Gate Header -->
              <div class="flex items-center gap-3 mb-3">
                <div class="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    class="w-full h-full object-cover"
                    height="48"
                    width="48"
                    [alt]="gate.name"
                    [ngSrc]="gate.iconUrl || 'logo/logo.svg'" />
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-lg font-semibold truncate">{{ gate.name }}</span>
                  <span class="text-gray-500 dark:text-gray-400 text-sm truncate">{{ gate.addressLine1 }}</span>
                </div>
              </div>
              <!-- Gate Details -->
              <div class="flex flex-col gap-2">
                <!-- Contact Numbers -->
                <div class="flex flex-col gap-2 mt-2">
                  <div class="flex items-center gap-2 p-2 bg-gray-50 dark:bg-surface-700 rounded-lg">
                    <div class="flex items-center justify-center w-8 h-8 rounded-full bg-primary-50 dark:bg-primary-900">
                      <i class="pi pi-phone text-primary"></i>
                    </div>
                    <div class="flex flex-col">
                      <span class="text-xs text-gray-500 dark:text-gray-400">Gate Number</span>
                      <span class="text-sm font-medium">{{ (gate.gateNumber | localPhone) || 'Not set' }}</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-2 p-2 bg-gray-50 dark:bg-surface-700 rounded-lg">
                    <div class="flex items-center justify-center w-8 h-8 rounded-full bg-primary-50 dark:bg-primary-900">
                      <i class="pi pi-server text-primary"></i>
                    </div>
                    <div class="flex flex-col">
                      <span class="text-xs text-gray-500 dark:text-gray-400">Server Number</span>
                      <span class="text-sm font-medium">{{ (gate.serverNumber | localPhone) || 'Not set' }}</span>
                    </div>
                  </div>
                </div>
                <!-- Status Indicators -->
                <div class="flex flex-wrap gap-2 mt-2">
                  @if (gate.hasTextAlarm) {
                    <p-tag class="text-xs" severity="warn" value="Text Alarm" />
                  }
                  @if (gate.hasGsmPte) {
                    <p-tag class="text-xs" severity="info" value="Push to Exit" />
                  }
                  @if (gate.hasDaytimeEntry) {
                    <p-tag class="text-xs" severity="success" value="Daytime Entry" />
                  }
                </div>
                <!-- Additional Info -->
                <div class="flex flex-wrap gap-2 mt-2">
                  <span class="text-gray-500 dark:text-gray-400 text-xs flex items-center">
                    <i class="pi pi-map-marker mr-1"></i>
                    {{ gate.city }}{{ gate.county ? ', ' + gate.county : '' }}
                  </span>
                  <span class="text-gray-500 dark:text-gray-400 text-xs flex items-center">
                    <i class="pi pi-wifi mr-1"></i>
                    {{ gate.phoneNetwork || 'No Network' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Empty State -->
      @if (gates.length === 0) {
        <div class="flex flex-col items-center justify-center p-6 text-center mt-6">
          <i class="pi pi-building text-5xl text-gray-500 mb-3"></i>
          <h2 class="text-xl font-semibold mb-2">No Gates Found</h2>
          <p class="text-gray-500 mb-4">Get started by adding your first gate</p>
          <button
            *appHasRole="UserRole.SuperAdmin"
            aria-label="Add Gate"
            class="p-button-primary"
            icon="pi pi-plus"
            label="Add Gate"
            pButton
            pRipple
            routerLink="/dashboard/gate/new"
            type="button"></button>
        </div>
      }
    </div>
  </div>
}
